module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAA7DAAAOwwHHb6hkAAAAB3RJTUUH4QoHAAwKisvkjQAAANBJREFUWMPtl0sOwjAMRGOLVXsADsGWE+Te9AKw5ShhO6wsWSifphAnEvG67byM3WhMAFxNrbRlXwjwVPO9U63o63rZ/eweGCo5sNKGkmiqlsezCJEEkJMcFdcQOTeiAN+cutYNthAXJ2MDzBbiOQh2nYutTp9ygQCYievC/UxdWyAudJ8BWtzN3H59N4zzF0yACfC/AAGeJDRY3wEBnmYLWPKaZRt0PGMdoS0gPrPhWDPQ2oVYMubYatUCIhXLx1xMhljNjjqi2/eT5bT1ev4GwRSZUy1rzJoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/puyo_b.png
// module id = jzv+
// module chunks = 1